export default __webpack_public_path__ + "static/media/Share.3a1d29d2.svg";